// extracted by mini-css-extract-plugin
module.exports = {"cpEditCoveragesButtonSection":"EditCoveragesSummary_cpEditCoveragesButtonSection__2MEux","cpEditCoveragesSaveButton":"EditCoveragesSummary_cpEditCoveragesSaveButton__2HJIw"};